import {useQuery, UseQueryResult} from "react-query";
import {getAllTypesContrat} from "./typeContrat.services";

export const useGetAllTypeContrat = ():UseQueryResult<TypeContrat[], Error>=>{
    return useQuery(["type_contrats"], getAllTypesContrat, {
        staleTime:60000,
        refetchOnWindowFocus:false,
    })
}